export default __webpack_public_path__ + "static/media/PurchaseLinkIndicatorSetValueActive.acec189d.svg";